<template>
    <div class="col-12">
        <div class="row">
            <div class="col-md-6 text-left" v-for="checkbox in this.privacyCheckboxes">
                <mcw-checkbox @change="onPrivacyCheck(checkbox)" :checked="privacy_obj[checkbox.db_name] === 1">
                    {{checkbox.label}}
                    <a v-if="!!checkbox.url" href="#" class="a3" @click.prevent="openPrivacyModal(checkbox)">
                        <i>{{$t('news.leggi')}} »</i>
                    </a>
                </mcw-checkbox>
            </div>
        </div>
        <modal v-if="this.show_modal_privacy" @close="show_modal_privacy = false" :show-title="false">
            <div slot="body">
                <iframe :src="this.privacy_link" class="w-100" style="height:500px;" frameBorder="0">
                    Browser not compatible
                </iframe>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from "./Modal";

export default {
    name: "IncPrivacyCheckboxes",
    components: {Modal},
    props: ['privacyCheckboxes', 'userInfo'],
    data() {
        return {
            privacy_obj: this.getprivacyObj(),
            privacy_link: null,
            show_modal_privacy: false
        }
    },
    methods: {
        getprivacyObj: function () {
            const obj = {};
            this.privacyCheckboxes.forEach((privacyCheckbox) => {
                obj[privacyCheckbox.db_name] = false;
            });
            if (this.userInfo && this.userInfo.privacy) obj.privacy = this.userInfo.privacy;

            return obj;
        },
        onPrivacyCheck: function (checkbox) {
            this.privacy_obj = Object.assign({}, this.privacy_obj, {
                [checkbox.db_name]:
                    this.privacy_obj[checkbox.db_name] === 1 ? 0 : 1,
            });

            this.$emit('onPrivacyChange', this.privacy_obj);
        },
        openPrivacyModal: function (checkbox) {
            this.privacy_link = checkbox.url;
            this.show_modal_privacy = true;
        },
    }
}
</script>
